import axios from "axios";
import { useEffect, useState } from "react";
import DataGrid from "react-data-grid";

function MyActivities(props) {
  
  const [activities, setActivities] = useState([]);

  const numberFormatter = ({ row, column }) => {
    const value = row[column.key];
    return value === 0 ? '' : value.toLocaleString();
  }

  const ActivitiesColDefs= [
        { key: 'index', name: 'No.',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        {key:'date', name:'Date', cellClass:'cell-center', headerCellClass:'cell-center'},
        { key: 'catalog', name: 'Catalog',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'businesses', name: 'Businesses',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'people', name: 'People',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'leadscopied', name: 'Leads Copied',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'peoplecopied', name: 'People Copied',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'exportcatalog', name: 'Export Catalog',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'exportleads', name: 'Export Leads',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
        { key: 'exportpeople', name: 'Export People',cellClass: 'cell-center', headerCellClass: 'cell-center', formatter: numberFormatter},
    ];

    const defaultColumnOptions={
        resizable: true,
        width:'auto',
        cellClass: 'cell-center',
        headerCellClass: 'cell-center'
      }

    useEffect(() => {
      const fetchActivities =async()=>{
        try{
          const response = await axios.get(`/getactivities/${props.userid}`);
          const data = response.data.map((row, idx) => ({...row, "index":idx+1}));
          setActivities(data);
          console.log("Activities: ",data);
        }
        catch(err){
          console.log("Error fetching actvities: ",err);
        }
      }
      fetchActivities();
    }, []);

  return (
     <div className="h-100">
                <div className='w-100 h-100 bg-white'>
                    <DataGrid 
                        columns={ActivitiesColDefs} 
                        // rows={rows} 
                        rows={activities}
                        // rowHeight={28} 
                        // headerRowHeight={32} 
                        className='h-100 w-100 rdg-light' 
                        defaultColumnOptions={defaultColumnOptions}
                    />
                </div>
            </div>
  );
}
export default MyActivities;